export const GET_POSITIONS_URL = `${BACKOFFICE_API_URL}/accounts/:id/positions`
export const ACCOUNTS = `${BACKOFFICE_API_URL}/accounting/trading-accounts`
